import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TokenAuth } from 'src/dto/users/users-dto';
import {
  clearLocalStorage,
  decryptToObject,
  environment,
} from 'src/environments/environment';
import { ModalService } from 'src/services/other/modal.service';
import { SharedDataService } from 'src/services/other/shared-data.service';
import { UsersService } from 'src/services/users/users.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  listCountry = [
    {
      name: 'IT',
      code: 'it',
      icon: '../../../assets/images/Country flag/italian.png',
    },
    {
      name: 'EN',
      code: 'en',
      icon: '../../../assets/images/Country flag/english.png',
    },
    // { name: 'FR', code: 'fr', icon: '../../../assets/images/Country flag/french.png' },
    // { name: 'ES', code: 'es', icon: '../../../assets/images/Country flag/spanish.png' },
    // { name: 'CN', code: 'cn', icon: '../../../assets/images/Country flag/chinese.png' },
    // { name: 'RU', code: 'ru', icon: '../../../assets/images/Country flag/russian.png' },
    // { name: 'DE', code: 'de', icon: '../../../assets/images/Country flag/deutch.png' },
  ];

  selectedCountry: { name: string; code: string; icon: string } | null = null;

  isCountryDropdownOpen: boolean = false;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private modalService: ModalService,
    private sharedData: SharedDataService,
    private userService: UsersService
  ) {}

  ngOnInit(): void {
    const savedCountry = localStorage.getItem('selectedCountry');
    this.selectedCountry =
      this.listCountry.find((x) => x.code == savedCountry) ||
      this.listCountry.find((x) => x.code == 'en') ||
      null;
    this.translate.use(this.selectedCountry.code);
  }

  selectCountry(country: { name: string; code: string; icon: string }) {
    this.selectedCountry = country;
    this.isCountryDropdownOpen = false;
    localStorage.setItem('selectedCountry', country.code);
    this.translate.use(country.code);
    // window.location.reload();
  }

  isSpecificRoute(): boolean {
    const currentRoute = this.router.routerState.snapshot.url;
    if (
      currentRoute.includes('/gallery/') ||
      currentRoute.includes('api/reset-password')
    ) {
      return true;
    }

    return currentRoute.includes('/gallery/');
  }

  isSpecificRole(area: string): boolean {
    const currentUser: TokenAuth = JSON.parse(
      decryptToObject(localStorage.getItem('CurrentUser'))
    );
    switch (area) {
      case 'pim':
        if (
          currentUser.roles.some(
            (role) =>
              environment.allowedPimRoles.includes(role) ||
              environment.allowedAdminOrSuperRoles.includes(role)
          )
        ) {
          return true;
        }
        return false;

      case 'dam':
        if (
          currentUser.roles.some(
            (role) =>
              environment.allowedDamRoles.includes(role) ||
              environment.allowedAdminOrSuperRoles.includes(role)
          )
        ) {
          return true;
        }
        return false;

      case 'dictionary':
        if (
          currentUser.roles.some(
            (role) =>
              environment.allowedDictionaryRoles.includes(role) ||
              environment.allowedAdminOrSuperRoles.includes(role)
          )
        ) {
          return true;
        }
        return false;

      case 'catalogs':
        if (
          currentUser.roles.some(
            (role) =>
              environment.allowedCatalogsRoles.includes(role) ||
              environment.allowedAdminOrSuperRoles.includes(role)
          )
        ) {
          return true;
        }
        return false;

      case 'users':
        if (
          currentUser.roles.some((role) =>
            environment.allowedSuperAdminRoles.includes(role)
          )
        ) {
          return true;
        }
        return false;

      default:
        return false;
    }
  }

  openCountryButton() {
    this.isCountryDropdownOpen = !this.isCountryDropdownOpen;
  }

  resetLocalStorage(location: string) {
    if (!this.router.url.includes(location)) {
      localStorage.removeItem('pageNumber');
      localStorage.removeItem('pageNumberC');
      localStorage.removeItem('scrollValueDam');
      localStorage.removeItem('ProductDamDetails');
      localStorage.removeItem('scrollValueCatalog');
      localStorage.removeItem('ProductCatalogDetails');
      sessionStorage.removeItem('searchQuery');
      sessionStorage.removeItem('filtersMapping');
      sessionStorage.removeItem('exportSchema');
      sessionStorage.removeItem('FiltersModels');
      sessionStorage.removeItem('FiltersQuery');
      sessionStorage.removeItem('modifyFromCatalog');
      sessionStorage.removeItem('productCache');
      sessionStorage.removeItem('CurrentSection');
      sessionStorage.removeItem('CurrentPath');
      sessionStorage.removeItem('allSectionHeritage');
      sessionStorage.removeItem('FilterProductsPref');
    }

    if (
      this.router.url.includes('pim') &&
      sessionStorage.getItem('modifyFromCatalog')
    ) {
      sessionStorage.removeItem('FiltersQuery');
      sessionStorage.removeItem('filtersMapping');
      localStorage.removeItem('scrollValueCatalog');
      sessionStorage.removeItem('modifyFromCatalog');
    }

    if (this.router.url.includes('/catalogues/product-details')) {
      sessionStorage.removeItem('FiltersQuery');
      sessionStorage.removeItem('searchQuery');
      sessionStorage.removeItem('productCache');
      localStorage.removeItem('pageNumber');
    }
  }

  getInitials(): string {
    const currentUser: TokenAuth = JSON.parse(
      decryptToObject(localStorage.getItem('CurrentUser'))
    );
    return currentUser.fc.toUpperCase() + currentUser.lc.toUpperCase() || '';
  }

  onLogoutButton() {
    this.modalService
      .confirm('LogoutRequest')
      .then(() => {
        this.modalService.open('Loading');

        this.userService.getLogout().subscribe({
          next: () => {
            clearLocalStorage();
            sessionStorage.clear();
            this.modalService.hide();
            this.router.navigate(['/login']);
          },
          error: () => {
            this.modalService.isError(true, 'Error');
            setTimeout(() => {
              this.modalService.hide();
            }, 1200);
          },
        });
      })
      .catch(() => {
        this.modalService.hide();
      });
  }
}
